import { IWeblinkIcons } from '../models/card-preview.interface'

export const iconsWeblink: IWeblinkIcons = {
   text: '../../../../assets/img/card-icons/new-text.svg',
   call: '../../../../assets/img/card-icons/new-call.svg',
   email: '../../../../assets/img/card-icons/new-email.svg',
   location: '../../../../assets/img/card-icons/new-location.svg',
   postcard: '../../../../assets/img/card-icons/new-postcard.svg',
   profile: '../../../../assets/img/card-icons/new-profile.svg',
   website: '../../../../assets/img/card-icons/new-website.svg',
   feature_content: '../../../../assets/img/card-icons/new-feature-content.svg',
   social_link: '../../../../assets/img/card-icons/new-social-link.svg',
   share: '../../../../assets/img/card-icons/share.png',
   connect: '../../../../assets/img/card-icons/connect.png',
   connect_green: '../../../../assets/img/card-icons/connect_green.png',
   facebook: '../../../../assets/img/card-icons/new-facebook.svg',
   instagram: '../../../../assets/img/card-icons/new-instagram.svg',
   twitter: '../../../../assets/img/card-icons/twitter.png',
   x: '../../../../assets/img/card-icons/X.svg',
   linkedin: '../../../../assets/img/card-icons/new-linkedin.svg',
   youtube: '../../../../assets/img/card-icons/new-youtube.svg',
   vimeo: '../../../../assets/img/card-icons/vimeo.png',
   z_buzz: '../../../../assets/img/card-icons/new-zbuzz.svg',
   brandcard: '../../../../assets/img/card-icons/brandcard.png',
   brandcard_white: '../../../../assets/img/card-icons/brandcard-white.png',
   appstore_web: '../../../../assets/img/card-icons/appstore-web.png',
   appstore: '../../../../assets/img/card-icons/appstore.svg',
   playstore_web: '../../../../assets/img/card-icons/playstore-web.png',
   playstore: '../../../../assets/img/card-icons/playstore.svg',
   plus_black: '../../../../assets/img/card-icons/plus-black.svg',
   plus_white: '../../../../assets/img/card-icons/plus-white.svg',
   zero_brandcard: '../../../../assets/img/card-icons/zero-brandcard-logo.svg',
   zero_logo: '../../../../assets/img/card-icons/zero-logo.svg',
   zero_brandcard_horizontal: '../../../../assets/img/card-icons/zero-brandcard-logo-horizontal_1.svg',
   zero_download: '../../../../assets/img/card-icons/zero-download.svg',
   back: '../../../../assets/img/card-icons/back.svg',
   back_dark: '../../../../assets/img/card-icons/back-dark.png',
   network_count: '../../../../assets/img/card-icons/network.png',
   note: '../../../../assets/img/card-icons/notes.svg',
   note_green: '../../../../assets/img/card-icons/notes-green.svg',
   note_white: '../../../../assets/img/card-icons/notes-white.png',
   arrow_up: '../../../../assets/img/card-icons/arrow-up.png',
   now_download: '../../../../assets/img/card-icons/now-download.png',
   download: '../../../../assets/img/card-icons/download.svg',
   sms: '../../../../assets/img/card-icons/sms.png',
   whatsapp: '../../../../assets/img/card-icons/whatsapp.png',
   sms_white: '../../../../assets/img/card-icons/new-sms.svg',
   whatsapp_white: '../../../../assets/img/card-icons/new-whatsapp.svg',
   download_now: '../../../../assets/img/card-icons/3.svg',
   cautious: '../../../../assets/img/card-icons/cautious.svg',
   close: '../../../../assets/img/card-icons/close.svg',
   x_close: '../../../../assets/img/card-icons/x-close.png',
   brand_varified: '../../../../assets/img/card-icons/brandcardverified.png',
   lock: '../../../../assets/img/card-icons/lock.svg',
   ctos_badge: '../../../../assets/img/ctos/ctos-badge.svg',

}